import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { DesiredResolutionFlow, EntitlementFlow } from '../../pageFlowData'
import { data } from './data'
import styles from './DesiredResolution.module.scss'

export const DesiredResolution: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    issue: { desiredResolution },
  } = state

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${DesiredResolutionFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_DESIRED_RESOLUTION', data: value })
    dispatch({ type: 'UPDATE_STEP', data: EntitlementFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: DesiredResolutionFlow.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string) => {
    handleTracking(id)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = data

  return (
    <div data-testid="desired-resolution">
      <PillButtonPage
        buttons={buttons}
        defaultValue={desiredResolution}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        pillButtonGroupStyle={styles.desiredResolutionPagePillButtons}
        title={title}
      />
    </div>
  )
}
